// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import locale from 'element-ui/lib/locale/lang/en'
import VueSession from 'vue-session'
import { Request } from 'fetchboi'
import vueCookie from 'vue-cookie'
import { baseAPIRoot } from './config/index.config'
import axios from 'axios'


Vue.use(ElementUI, { locale })
Vue.use(VueSession)
Vue.use(vueCookie)

// axios.interceptors.request.use(
//   (config) => {
     let token = Vue.cookie.get('token')

//     if (token) {
//       config.headers['Authorization'] = `Bearer ${ token }`;
//     }

//     return config;
//   }, 

//   (error) => {
//     return Promise.reject(error);
//   }
// );

axios.defaults.headers.common['Authorization'] = `Bearer ${ token }`;

Request.init(baseAPIRoot)
Request.getToken = () => {
  return Vue.cookie.get('token')
}

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App},
  template: '<App/>' 
})



// WEBPACK FOOTER //
// ./src/main.js